import { render, staticRenderFns } from "./PopupCart.vue?vue&type=template&id=bcd04966&"
import script from "./PopupCart.vue?vue&type=script&lang=js&"
export * from "./PopupCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports